
















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Action, namespace, Getter } from 'vuex-class';
import TaskItem from '@/components/TaskItem.vue';
import CommentItem from '@/components/CommentItem.vue';
import CommentInput from '@/components/CommentInput.vue';
import { TASK_STATUS, ROLES } from '../config/constants';
import { Task } from '../stores/modules/tasks';
import { User } from '../stores/modules/user';

const tasks = namespace('tasks');
const user = namespace('user');

@Component({
  components: {
    TaskItem,
    CommentItem,
    CommentInput
  }
})
export default class TaskItemBoundary extends Vue {
  @Prop({ type: Object }) task!: Task;
  @Prop({ type: Boolean, default: true }) showBorder!: Task;

  @tasks.Action('changeStatus') changeStatus!: (payload: { task: Task; reset: boolean }) => void;
  @tasks.Action('removeTask') removeTask!: (payload: Task) => void;
  @tasks.Action('updateTask') updateTask!: (payload: Partial<Task>) => void;
  @tasks.Action('addComment') addComment!: (payload: { task: Task; text: string }) => void;
  @tasks.Getter('isNewlyCreated') isNewlyCreated!: (id: string) => boolean;
  @user.Getter('hasRole') hasRole!: (role: string) => boolean;
  @user.State('me') me!: User;

  editMode = false;
  open = false;
  comment = '';

  get editing() {
    return this.editMode || this.isNewlyCreated(this.task._id);
  }

  get disabled() {
    return this.task.status.step === TASK_STATUS.DONE;
  }

  get showRevert() {
    return this.task.status.step !== TASK_STATUS.TODO;
  }

  get showUpdate() {
    return this.hasRole(ROLES.MANAGER) || true;
  }

  get comments() {
    return this.task.data.comments;
  }

  addNewComment(text: string) {
    if (!text.trim()) {
      return;
    }

    this.addComment({ task: this.task, text });
    this.comment = '';
  }

  saveEdit(text: string) {
    this.editMode = false;
    this.updateTask({ ...this.task, data: { ...this.task.data, text } });
  }

  getTaskIcon(status: string) {
    switch (status) {
      case TASK_STATUS.TODO:
        return 'mdi-checkbox-blank-circle-outline';
      case TASK_STATUS.NEEDS_APPROVAL:
        return 'mdi-progress-check';
      case TASK_STATUS.DONE:
        return 'mdi-checkbox-marked-circle';
      default:
        return 'mdi-checkbox-blank-circle-outline';
    }
  }
}
